import React, { useRef, forwardRef } from "react";
import { createPolymorphicComponent } from "@mantine/core";

export interface IDrawerHeaderProps {
  children?: React.ReactNode;
}

export const _DrawerHeader = forwardRef<HTMLDivElement, IDrawerHeaderProps>(
  (props, ref) => {
    const { children } = props;

    const itemRef = useRef<any>();

    return <>{children}</>;
  }
);

_DrawerHeader.displayName = "@modir/ui-mantine/DrawerHeader";

export const DrawerHeader =
  createPolymorphicComponent<"div", IDrawerHeaderProps>(_DrawerHeader);
